module.exports = __webpack_public_path__ + "media/images/united kingdom-flag-round-e013f05d5a195b7d5c2c750526100ace.png";